<template>
  <v-row justify="center">
    <v-dialog :value="dialog" max-width="500" @input="$emit('closeModal')">
      <v-card>
        <v-card-title class="headline accent--text pb-4" style="word-break: break-word">
          {{ message }}
        </v-card-title>
        <v-card-text outlined tile />

        <v-card-actions class="px-6">
          <v-spacer />
          <v-btn
            :loading="loading"
            color="success"
            text
            @click="confirm"
          >
            {{ successBtnText }}
          </v-btn>
          <v-btn
            :disabled="loading"
            text
            color="lightGrey"
            @click="closeConfirmModal"
          >
            {{ cancelBtnText }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
export default {
  props: {
    dialog: Boolean,
    message: {
      type: String,
      default: '',
    },
    loading: {
      type: Boolean,
      default: false,
    },
    successBtnText: {
      type: String,
      default: 'Да',
    },
    cancelBtnText: {
      type: String,
      default: 'Нет',
    },
  },

  methods: {
    confirm() {
      this.$emit('confirm')
    },

    closeConfirmModal() {
      this.$emit('closeConfirmModal')
    },
  },
}
</script>

<style lang="scss" scoped>
.border-top {
  border: 0 !important;
  border-top: 1px solid rgba(0, 0, 0, 0.12) !important;
}

.theme--light.v-btn.v-btn--disabled {
  color: #dadada !important
}
</style>
